import { ENV } from '@/config'

/**
 * Starts MSW mock service worker in development.
 * Called in main.tsx before rendering the app.
 */
export const initMocks = async (): Promise<void> => {
  if (!ENV.FLAGS.MOCK_API) return

  const { worker } = await import('./browser')
  await worker.start({
    onUnhandledRequest: 'warn', // Warn about unhandled API calls in dev
  })
}
